import React from "react";

import BagObjectAppDataForm from "./BagObjectAppDataForm";

export default function BagObjectDetail(props: {
  bagObject: IBagObject;
}): React.JSX.Element {
  /**
   * A detailed view of a BAG object.
   */
  const bagObject = props.bagObject as IBagObject;

  return (
    <div>
      <ul className="m-0 ps-3">
        <li>
          <strong>Adres:</strong> {bagObject.addressFormatted}
        </li>
        <li>
          <strong>Oppervlakte:</strong> {bagObject.floorArea} m²
        </li>
        {bagObject.yearOfConstruction ? (
          <li>
            <strong>Bouwjaar:</strong> {bagObject.yearOfConstruction}
          </li>
        ) : (
          <></>
        )}
        <li>
          <strong>Gebruiksdoelen:</strong> {bagObject.functions.join(", ")}
        </li>
        <li>
          <strong>Status:</strong> {bagObject.status}
        </li>
        {bagObject.buildingStatus ? (
          <li>
            <strong>Pand status:</strong> {bagObject.buildingStatus}
          </li>
        ) : (
          <></>
        )}
        <li>
          <strong>Bekijk in:</strong>{" "}
          <ul>
            <li>
              <a
                href={`https://bagviewer.kadaster.nl/lvbag/bag-viewer/index.html#?searchQuery=${bagObject.id}`}
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                BAG Viewer
              </a>
            </li>
            <li>
              <a
                href={`https://omgevingswet.overheid.nl/regels-op-de-kaart/documenten?regelsandere=regels&locatie-stelsel=ETRS89&locatie-x=${bagObject.centroid.coordinates[0]}&locatie-y=${bagObject.centroid.coordinates[1]}`}
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                Omgevingsloket
              </a>
            </li>
            <li>
              <a
                href={`https://kadastralekaart.com/adres/0/${bagObject.id}`}
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                Kadastrale Kaart
              </a>
            </li>
            <li>
              <a
                href={`https://www.google.com/maps/place/${bagObject.addressFormatted}`}
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                Google Maps
              </a>
            </li>
          </ul>
        </li>
      </ul>

      <hr />

      <BagObjectAppDataForm bagObject={bagObject} />
    </div>
  );
}
